// extracted by mini-css-extract-plugin
export var quantityInput = "_k1-0";